module.exports = __webpack_public_path__ + "static/media/main_slider_1.ee8d96e8.jpg";